import React from 'react';
import { Summary } from '../Summary';
import { useManyReveal } from './many-reveal-machine';

export function ManyReveal() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [state, send] = useManyReveal();

  return (
    <Summary
      currentGribble={state.context.gribbles[state.context.page]}
      gribbleCount={state.context.gribbles.length}
      index={state.context.page}
      last={state.context.gribbles.length === state.context.page + 1}
      first={0 === state.context.page}
      next={() => send('next')}
      prev={() => send('previous')}
      finish={() => send('finish')}
    />
  );
}
